import React from 'react';
import { BaseButton, ButtonSize, NativeButtonProps } from './BaseButton';

type Props = NativeButtonProps & {
  size?: ButtonSize;
  stretch?: boolean;
};

export const PrimaryButton = (props: Props) => <BaseButton buttonStyle="primary" {...props} />;
